// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMinusOutlinedSvg from "@fishx/icons-svg/es/asn/PMinusOutlined";
import FishxIcon from '../components/FishxIcon';

var PMinusOutlined = function PMinusOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMinusOutlinedSvg
  }));
};

PMinusOutlined.displayName = 'PMinusOutlined';
export default React.forwardRef(PMinusOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMinusOutlined.js
// module id = 3507
// module chunks = 0